import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import ProductionBatchCard from './ProductionBatchCard';

const ProductionLotManagerDrawer = ({
  batch,
  machines,
  personnel,
  userRole,
  userRoleTypes,
  canOpenWorkshop,
  batchHandlers,
  onClose,
}) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  if (!batch) return null;

  const {
    onUpdate,
    onDelete,
    onStatusChange,
    onAssignMachine,
    onCreateSheet,
    onLaunchProduction,
    onAssignResponsible,
    onGenerateInvoice,
  } = batchHandlers;

  return (
    <div className="fixed inset-0 z-[100] flex justify-end">
      <button
        type="button"
        className="absolute inset-0 bg-black/50"
        aria-label="Fermer"
        onClick={onClose}
      />
      <aside
        className="relative w-full max-w-lg h-full bg-background border-l border-border shadow-xl flex flex-col"
        role="dialog"
        aria-modal="true"
        aria-labelledby="lot-drawer-title"
      >
        <header className="flex items-center justify-between gap-3 px-4 py-3 border-b border-border shrink-0">
          <div className="min-w-0">
            <h2 id="lot-drawer-title" className="font-semibold text-foreground truncate">
              Lot {batch.batchNumber}
            </h2>
            <p className="text-xs text-muted-foreground truncate">{batch.patientName}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="w-10 h-10 rounded-lg hover:bg-muted flex items-center justify-center shrink-0"
          >
            <Icon name="X" size={20} />
          </button>
        </header>
        <div className="flex-1 overflow-y-auto p-4">
          <ProductionBatchCard
            batch={batch}
            machines={machines}
            operators={personnel}
            userRole={userRole}
            userRoleTypes={userRoleTypes}
            onUpdate={(data) => onUpdate(batch.id, data)}
            onDelete={() => {
              onDelete(batch.id);
              onClose?.();
            }}
            onStatusChange={(status) => onStatusChange(batch.id, status)}
            onAssignMachine={(machineId) => onAssignMachine(batch.id, machineId)}
            onCreateSheet={(sheetData) => onCreateSheet(batch.id, sheetData)}
            onLaunchProduction={() => onLaunchProduction(batch.id)}
            onAssignResponsible={onAssignResponsible}
            onGenerateInvoice={() => onGenerateInvoice(batch)}
            canOpenWorkshop={canOpenWorkshop}
          />
        </div>
      </aside>
    </div>
  );
};

export default ProductionLotManagerDrawer;
